const CartActions = (() => {
  function add(data) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: data
    }).then(response => response.json()).catch(error => {
      console.error(window.cartStrings.error, error);
    });
  }

  function get() {
    return fetch(`${Shopify.routes.root}cart.js`).then(response => response.json());
  }

  function update(data) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`
      },
      body: data
    }).then(response => response.text()).catch(error => {
      console.error(window.cartStrings.error, error);
    });
  } // Public API


  return {
    add: add,
    get: get,
    update: update
  };
})();

export { CartActions };
